import React from 'react';

interface Props {
  backgroundColor?: string;
  paddingVertical?: number;
  paddingHorizontal?: number
}

/**
 * Container for wrapping main content of the page
 * @param param0
 * @returns
 */
export const MainContainer: React.FC<Props> = ({
  children,
  backgroundColor,
  paddingHorizontal = 4,
  paddingVertical = 4
}) => {
  return (
    <div
      style={{ backgroundColor: `${backgroundColor || 'rgba(249, 249, 249, 1)'}`, minHeight: '100vh'}}
      className={`px-${paddingHorizontal} py-${paddingVertical}`}
    >
      {children}
    </div>
  );
};
